import { SiManageiq } from "react-icons/si";

import { AiOutlinePlus } from "react-icons/ai";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
export default function BtnPage({ setShow, setShowStoreModal }) {
  return (
    <div className="container ">
      <div className=" d-flex mx-3 justify-content-end">
        <>
          <button
            className="bt-add"
            data-bs-toggle="modal"
            data-bs-target="#AddStoreModal"
            onClick={() => {
              setShowStoreModal(true);
            }}
          >
            <AiOutlinePlus />
            اضافه کردن فروشگاه
          </button>
        </>
        <>
          <button
            className="bt-filter"
            data-bs-toggle="modal"
            data-bs-target="#FilterStoreModal"
          >
            <FaFilter />
            جستجو فروشگاه
          </button>
        </>
      </div>
    </div>
  );
}
